var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-spotlight",
      class: [
        _vm.showSummary ? "c-spotlight--theme-two" : null,
        _vm.theme ? "u-color--theme-" + _vm.theme : null
      ]
    },
    [
      _c("a", { staticClass: "c-spotlight-link", attrs: { href: _vm.link } }, [
        _c(
          "div",
          {
            staticClass: "c-spotlight__background-image",
            style: "background-image: url(" + _vm.image + ")"
          },
          [
            _c(
              "div",
              { staticClass: "c-spotlight__content u-color__background" },
              [
                _c("div", { staticClass: "c-spotlight__inner" }, [
                  _vm.title
                    ? _c(
                        "h2",
                        {
                          staticClass:
                            "c-spotlight__title u-color__title u-color__title"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.title) +
                              "\n          "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "svg",
                    { staticClass: "c-spotlight__icon u-color__icon" },
                    [
                      _c("use", {
                        attrs: { "xlink:href": "#arrow-right--round" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.showSummary
                  ? _c(
                      "p",
                      {
                        staticClass:
                          "c-spotlight__summary u-color__summary u-color__summary"
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.summary) + "\n        "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "c-spotlight__date u-color__ribbon" }, [
                  _c(
                    "svg",
                    { staticClass: "c-spotlight__date-icon u-color__icon" },
                    [_c("use", { attrs: { "xlink:href": "#clock" } })]
                  ),
                  _vm._v("\n          " + _vm._s(_vm.date) + "\n        ")
                ])
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcd75568", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcd75568","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/developers/spotlight/Spotlight.vue
// module id = 547
// module chunks = 0